import Vue from 'vue'
import { HIDE_COLUMNS } from '@/constants/dataTable'

interface Methods {
  isVisibleColumn: (directory: string, key: string) => boolean
}

export default Vue.extend<{}, Methods, {}, {}>({
  methods: {
    isVisibleColumn(directory, key) {
      return !(HIDE_COLUMNS as { [key: string]: string[] })[
        directory.toLowerCase()
      ].includes(key)
    },
  },
})
